<template>
  <v-card>
    <v-card-title>
      <div class="layout row ma-0">
        <div class="title">{{title}}</div>
        <v-spacer></v-spacer>
        <div class="caption">
          <v-icon>trending_up</v-icon>
        </div>
      </div>
    </v-card-title>
    <v-card-text class="white--text">
      <e-chart
        :path-option="defaultOption"
        height="400px"
        width="100%"
      ></e-chart>
    </v-card-text>
  </v-card>
</template>

<script>
import EChart from '@/components/chart/echart'
import API from '@/api'

export default {
  components: {
    EChart
  },
  props: {
    title: String,
    data: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      width: '99%'
    }
  },
  mounted () {
    this.width = '100%'
  },
  computed: {

    defaultOption () {
      return [
        ['dataset.source', this.data],
        ['legend.show', true],
        ['legend.bottom', '0'],
        ['color', ['#4572a7', '#93a9cf', '#ff5252']],
        ['xAxis.show', false],
        ['yAxis.show', false],
        ['series[0].type', 'pie'],
        ['series[0].avoidLabelOverlap', false],
        ['series[0].radius', ['40%', '60%']]
      ]
    }

  }

}
</script>

<style>
</style>
